export default __webpack_public_path__ + "static/media/HelpUSell.9c4fd8c6.jpg";